module.exports = __webpack_public_path__ + "img/CliSet3.d2548bf6.jpg";